<template>
    <div
        class="background-arrow-outline d-flex justify-center align-center"
        @click="buttonAction"
        :style="style"
    >
        <img src="../../assets/img/arrows/flecha-volver_2.svg" alt="" srcset="" />
        <div class="position-absolute">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'arrow-btn',
    props: {
        width: { type: [Number, String], default: '20vh' },
        height: { type: [Number, String], default: '5vh' },
    },
    // mounted() {
    //     document.querySelector('.background-arrow-outline').style.width = `${this.width}vh`
    //     document.querySelector('.background-arrow-outline').style.height = `${this.height}vh`
    // },
    computed: {
        style() {
            return `width: ${this.width}; height:${this.height};`
        },
    },
    methods: {
        buttonAction() {
            this.$emit('brClick')
        },
    },
}
</script>

<style>
.background-arrow-outline {
    /* background: url(../../assets/img/arrows/flecha-volver_2.svg); */
    background-repeat: round;
}
.background-arrow-outline img {
    width: 100%;
}
.background-arrow-outline:hover {
    cursor: pointer;
}
</style>
